'use client'

import classNames from 'classnames'
import { CSSProperties, FunctionComponent } from 'react'
import styles from './SiteCard.module.css'
import VenueLinkBlock from '../VenueLinkBlock/VenueLinkBlock'

type Props = {
  site: SiteCardT
}

const SiteCard: FunctionComponent<Props> = ({ site }: Props) => {
  const {
    variant,
    title,
    logo,
    className,
    logoAltText,
    backgroundUrl,
  } = site
  // a custom property, so the theme's gradient stays layered on top
  const style = backgroundUrl
    ? { '--background-image': `url(${JSON.stringify(backgroundUrl)})` } as CSSProperties
    : undefined

  return (
    <section
      className={
        classNames(
          styles.SiteCard,
          className,
        )
      }
      style={style}
      data-theme={site.urlSlug}
      data-variant={variant}
      data-testid="site-card"
    >
      <div className={classNames(styles.LocationSection, styles.Logo)}>
        {/* Logo of Exhibit */}
        <div className={styles.Logo}>
          {logo && <img src={logo} alt={logoAltText} />}
        </div>
        {/* Location of Exhibit */}
        <div className={styles.Title}>
          {title}
        </div>
      </div>
      <div className={styles.CtaContainer}>
        <VenueLinkBlock
          site={site}
          siteCardVariant={variant}
        />
      </div>
    </section>
  )
}

export default SiteCard
